module.exports = __webpack_public_path__ + "static/media/huang_rin.af6aa9aa.png";